/**
 * Equalizes the height of matching elements per row.
 *
 * Markup:
 *   <div data-equal-group>
 *     ... <div data-equal-item>…</div> ...
 *   </div>
 *
 * Items are grouped by their offsetTop, so on mobile (one item per row) nothing
 * is forced and each row equalizes independently when items sit side by side.
 */
function equalizeHeights() {
  document.querySelectorAll("[data-equal-group]").forEach((group) => {
    const items = [...group.querySelectorAll("[data-equal-item]")];
    if (!items.length) return;

    // Reset so measurements reflect natural content height.
    items.forEach((el) => (el.style.height = "auto"));

    // Bucket items into rows by their vertical offset.
    const rows = new Map();
    items.forEach((el) => {
      const key = Math.round(el.offsetTop);
      if (!rows.has(key)) rows.set(key, []);
      rows.get(key).push(el);
    });

    rows.forEach((row) => {
      if (row.length < 2) return; // single item on its row → leave natural
      const max = Math.max(...row.map((el) => el.offsetHeight));
      row.forEach((el) => (el.style.height = `${max}px`));
    });
  });
}

let resizeTimer;
function onResize() {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(equalizeHeights, 150);
}

window.addEventListener("load", equalizeHeights);
window.addEventListener("resize", onResize);
// Re-run once fonts settle (text reflow can change heights).
if (document.fonts && document.fonts.ready) {
  document.fonts.ready.then(equalizeHeights);
}
